import { createContext, useContext } from 'react';
import { SavedSearch } from '@/types/flyer';

import { FlyerType } from '@/config/constants';
import { TrackingData } from '@/hooks';

export type FlyersContextType = {
  setSavedSearches: (savedSearch: Array<SavedSearch>) => void;
  savedSearches: Array<SavedSearch>;
  saveRecentSearches: (recentSearch: Array<string>) => void;
  recentSearches: Array<string>;
  toggleSavedSearches: (savedSearch: string) => void;
  addRecentSearch: (recentSearch: string) => void;
  removeRecentSearch: (recentSearch: string) => void;
  activeTab: string;
  onChangeFlyerType: (trackingData?: TrackingData) => void;
  isSchoolTabSelected: boolean;
  targetTab: string;
};

const FlyersContext = createContext<FlyersContextType>({
  setSavedSearches: (savedSearches: Array<SavedSearch>) => null,
  toggleSavedSearches: (savedSearch: string) => null,
  addRecentSearch: (recentSearch: string) => null,
  removeRecentSearch: (recentSearch: string) => null,
  savedSearches: [],
  saveRecentSearches: (recentSearch: Array<string>) => null,
  recentSearches: [],
  activeTab: FlyerType.school,
  onChangeFlyerType: () => null,
  isSchoolTabSelected: true,
  targetTab: FlyerType.community,
});

export const useFlyersContext = () => useContext(FlyersContext);

export default FlyersContext;
